module.exports = __webpack_public_path__ + "img/panama.149c2f7.png";